var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconTie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.50116 6.49841C7.15811 6.49841 8.50134 5.15518 8.50134 3.49823C8.50134 1.84127 7.15811 0.498047 5.50116 0.498047C3.8442 0.498047 2.50098 1.84127 2.50098 3.49823C2.50098 5.15518 3.8442 6.49841 5.50116 6.49841Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.77011 8.12753C9.29741 7.88508 8.54444 7.54498 7.64401 7.30203C7.51901 7.26687 7.38717 7.33647 7.34369 7.45903L6.31892 10.318L6.00866 8.76624L6.4877 7.32913C6.51308 7.25295 6.5004 7.16897 6.45303 7.10376C6.40616 7.03858 6.33096 7 6.25038 7H4.75029C4.66971 7 4.59452 7.03858 4.54764 7.10376C4.50027 7.16895 4.48757 7.25295 4.51297 7.32913L4.99202 8.76624L4.68176 10.318L3.65698 7.45903C3.61353 7.33647 3.48119 7.26711 3.35666 7.30203C2.45621 7.54498 1.70323 7.88508 1.23057 8.12753C0.471708 8.5172 0 9.28628 0 10.1342V10.5002C0 11.0518 0.448761 11.5003 1.00007 11.5003H4.75029H6.25038H10.0006C10.5519 11.5003 11.0007 11.0518 11.0007 10.5002V10.1342C11.0006 9.28628 10.5289 8.5172 9.77011 8.12753Z",
    fill: "#888888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconTie);
export default __webpack_public_path__ + "static/media/profileIconTie.411b21a3511cfe75e21155c045954380.svg";
export { ForwardRef as ReactComponent };